<template>
  <b-container class="container-layout" fluid>
    <Form class="mt-n5" :GetKeysAsesor="GetKeysAsesor" :premedios="premedios" />

    <b-row class="mt-5" align-h="center">
      <Search :GetKeysAsesor="GetKeysAsesor" :keys="keys" />
    </b-row>
  </b-container>
</template>

<script>
import Form from "@/components/Global/FormKey";
import Search from "@/components/Global/SearchKey";
import moment from "moment";

export default {
  name: "Keys",
  components: { Form, Search },
  data: () => ({
    keys: [],
    premedios: []
  }),
  created() {
    this.$store.dispatch("setModulo", "KEY DE ACCESO");

    this.GetKeysAsesor();
  },
  methods: {
    GetKeysAsesor() {
      let user = JSON.parse(localStorage.getItem("userdata"));
      let id = user.id;
      this.$store
        .dispatch("GetKeysAsesorAll", id)
        .then(response => {
          let now = moment().subtract(1, "days").format();
          this.keys = response.data.keys;
          this.keys.forEach(element => {
            let hasta = element.hasta;
            if (moment(hasta).isBefore(now) && element.activo === true) {
              element.estado = 'Caducado';
            }
            if (element.activo === false) {
              element.estado = 'Inhabilitado';
            }
            if (moment(hasta).isAfter(now) && element.activo === true) {
              element.estado = 'Vigente';
            }
          });
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  },
  filters: {
    fixed(value) {
      return parseFloat(value).toFixed(0);
    }
  }
};
</script>
<style scoped>
</style>